@if (!loading) {
  @if (!error) {
    <router-outlet></router-outlet>
  }
  @if (error) {
    <app-error></app-error>
  }
}
